export const PROCESS_CITATION = 'PROCESS_CITATION'
export const CACHE_CITATION = 'CACHE_CITATION'
